<template>
    <BreadCrumb PageTitle="Ajouter une zone tarifaire" />
    <AddTariffZone/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddTariffZone from "@/components/ZoneTarifaire/AddTariffZone.vue";
  
    export default defineComponent({
      name: "AddTariffZonePage",
      components: {
        BreadCrumb,
        AddTariffZone,
      },
    });
  </script>